import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=41cd5700&scoped=true&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"
import style0 from "./tab.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./tab.vue?vue&type=style&index=1&id=41cd5700&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41cd5700",
  null
  
)

export default component.exports